export enum LandlordSwitchStep {
  PropertyLookup,
  Energy,
  Landlord,
  Billing,
  Consent,
  Summary,
  Confirmation,
}
